export default {
  token: '',
  //表格数据
  tableData: [],
  //数据条数
  total: 0,
  //车系列表
  car_series_list: [],
  //车组列表
  car_group_list: [],
  //车型列表
  car_kind_list: [],
  //车标图片类型
  iconTypeID_list: [],

  //售机类型列表
  equip_type_list: [],
  //售机类型列表(去掉重复路径)
  equip_typeUnique_list: [],
  //设备机型的授权车型列表
  authoriz_carModel_list: [],
  //设备机型的未授权车型列表
  unauthoriz_carModel_list: [],
  //设备机型ID
  productInfoID: null,
  carKindIDs: null,

  //拓展文件信息列表
  fileInfo_all: [],


  //语言类型列表
  lang_list: [],
  //语言和所有项列表
  lang_list_all: [],
  //所有语言列表
  all_lang_list: [],
  //所有语言列表(包含all项)
  all_lang_list_all: [],
  //用户设备列表
  equip_user_list: [],

  //通用文件类型列表
  fileapp_list: [],

  //检测类型
  checkType_list: []

}


// WEBPACK FOOTER //
// ./src/store/state.js